import { useEffect } from 'react';
import { Button, Form, type FormProps, message, Modal } from 'antd';
import { updateSystemPrompt } from '@/services/api/chatService';
import { HttpStatusCode } from 'axios';
import TextArea from 'antd/es/input/TextArea';
import { useTranslation } from 'react-i18next';

type FieldType = {
  name?: string;
};

const ModalUpdateSystemPrompt: any = ({
  inquiry,
  open,
  setSelectedInquiry,
  onCancel,
}: any) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (open && inquiry) {
      form.setFieldValue('default_prompt', inquiry?.default_prompt);
    }
  }, [inquiry, open, form]);

  const onFinish: FormProps<FieldType>['onFinish'] = async (values: any) => {
    const response = await updateSystemPrompt(inquiry.id, {
      default_prompt: values.default_prompt,
    });
    if (!response.success) {
      return;
    }
    setSelectedInquiry({
      ...inquiry,
      default_prompt: values.default_prompt,
    });
    onCancel();
  };

  return (
    <div>
      <Modal
        title={t('home.chat.modals.prompt.title')}
        width={'50%'}
        open={open}
        destroyOnClose
        footer={
          <Button type="primary" onClick={() => form.submit()}>
            {t('home.chat.modals.prompt.confirm')}
          </Button>
        }
        onCancel={onCancel}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item name="default_prompt">
            <TextArea
              placeholder={t('home.chat.modals.prompt.placeholder')}
              rows={6}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalUpdateSystemPrompt;
